import { ExternalLink } from "@/components/ExternalLink";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import { Tables } from "../../../gen/tableNames/tables";

export type G4MetaData = {
  id: number;
  portfolio_id?: number | null;
  portfolio_name?: string | null;
  needs_lookthrough?: boolean | null;
  created_at?: string | null;
  updated_at?: string | null;
};

const t = (key: string, defaultValue: string) =>
  i18n.t(`${Tables.G4_METADATA}.columns.${key}`, {
    ns: "tables",
    defaultValue,
  });

export const g4_metadata_columns: ColumnDef<G4MetaData>[] = [
  {
    accessorKey: "id",
    header: t("id", "ID"),
  },
  {
    accessorKey: "portfolio_name",
    header: () => t("portfolio_name", "Portefeuille"),
    cell: ({ row }) => {
      const id = row.original.portfolio_id;
      const name = row.original.portfolio_name;
      if (!id || !name) return "";
      return (
        <ExternalLink
          href={toWorkspacePath(`/admin/qtl - referential/strategies/${id}`)}
          className="text-xs"
          underline="hover"
        >
          {name}
        </ExternalLink>
      );
    },
  },
  {
    accessorKey: "needs_lookthrough",
    header: () => t("needs_lookthrough", "needs_lookthrough"),
  },

  {
    id: "actions",
    cell: ({ row }) => {
      return (
        <div className="flex justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
